export const ADMIN_NAV = [
  { to: "/admin", label: "Overview" },
  { to: "/admin/companies", label: "Companies" },
  { to: "/admin/jobs", label: "Jobs" },
  { to: "/admin/people", label: "People" },
  { to: "/admin/payments", label: "Payments" },
] as const
